/// <amd-module name="Test/TestResultWorkItems/Actions/WorkItemsActionHub" />
import { WorkItemTypes } from 'Test/TestResultWorkItems/Common';
import { Action } from 'VSS/Reflux/Action';
import { WorkItem, WorkItemStateColor } from 'Wit/Clients/Wit/Contracts/WorkItemTracking';
import { WorkItemTypeColorAndIcon } from 'WorkItemsHub/External/NewWorkItem/WorkItemTypeColorAndIconsProvider';

export interface IWorkItemWithColorsAndIcon {
    workItem: WorkItem;
    stateColor: string;
    icon: string;
    color: string;
}

export interface IWorkItemAndMaps {
    bugs: WorkItem[];
    requirements: WorkItem[];
    stateAndColorMap: { [key: string]: WorkItemStateColor[] } | undefined;
    colorAndIconMap: WorkItemTypeColorAndIcon[] | undefined;
}

export class WorkItemsActionsHub {
    static readonly CHILD_SCOPE = "CHILD_SCOPE";
    public onError = new Action<string>(WorkItemsActionsHub.CHILD_SCOPE);
    public workItemsLoaded = new Action<IWorkItemAndMaps>(WorkItemsActionsHub.CHILD_SCOPE);
    public onSort = new Action<{ workItems: IWorkItemWithColorsAndIcon[]; workItemType: WorkItemTypes }>(WorkItemsActionsHub.CHILD_SCOPE);
    public onDeleteWorkItemLink = new Action<{ workItems: WorkItem[]; workItemType: WorkItemTypes}>(WorkItemsActionsHub.CHILD_SCOPE);
    public clearState = new Action<null>(WorkItemsActionsHub.CHILD_SCOPE);
    public updateWorkItems = new Action<{ updatedWorkItem: WorkItem;  workItemType: WorkItemTypes}>(WorkItemsActionsHub.CHILD_SCOPE);
}
